export const IS_ROLEX_V7_ENABLED = process.env.NEXT_PUBLIC_FEATURE_ROLEX_V7 === 'true'
export const IS_NEW_WATCHES_2025_ENABLED =
  process.env.NEXT_PUBLIC_FEATURE_NEW_WATCHES_2025 === 'true'
export const IS_PRE_OWNED_NAVIGATION_ENABLED =
  process.env.NEXT_PUBLIC_FEATURE_PRE_OWNED_NAVIGATION === 'true'
export const IS_EMARSYS_NEWSLETTER_FORM_ENABLED =
  process.env.NEXT_PUBLIC_FEATURE_EMARSYS_NEWSLETTER_FORM === 'true'
